var map = {
	"./bp_navbar.jpg": 1357,
	"./gallery1.png": 3427,
	"./gallery10.png": 2269,
	"./gallery11.png": 3479,
	"./gallery2.png": 2489,
	"./gallery3.png": 6270,
	"./gallery4.png": 2237,
	"./gallery5.png": 9615,
	"./gallery6.png": 9196,
	"./gallery7.png": 4013,
	"./gallery8.png": 7598,
	"./gallery9.png": 2173,
	"./linkedin.png": 8518,
	"./project1.jpg": 5489,
	"./project2.jpg": 7209,
	"./project3.png": 4692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;